/* Dependencies */
import styled from 'styled-components';

/* Components */
import { Button } from 'lego-dist';

export const InputGrid = styled.div.attrs(({ className }) => ({
  className: `StylesMoveTeacherInputInputGrid ${className}`,
}))`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
`;

export const InputGroup = styled.div.attrs(({ className }) => ({
  className: `StyledMoveTeacherInputGroup ${className}`,
}))`
  display: block;
  margin-bottom: 16px;
  position: relative;

  .legoSelecterOptionsList .legoSelecterOptionItem {
    display: flex;
    align-items: center;
  }

  .legoSelecterOptionsContainer {
    margin-top: 0;
  }

  .legoSelecterOptionIndicator {
    top: 12px;
  }

  .legoSelecterOptionsList {
    margin-top: 0;
  }
`;

export const Wrapper = styled.div.attrs(() => ({
  className: 'MoveTeacherWrapper',
}))`
  display: block;
  padding: 20px 20px 30px 20px;
`;

export const Label = styled.label.attrs(() => ({
  className: 'StyledMoveTeacherLabel',
}))`
  font-size: 14px;
  font-weight: bold;
  margin-top: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const WrapperSelecter = styled.div.attrs(() => ({
  className: 'WrapperSelecterMoveTeacher',
}))`
  display: block;
  position: relative;
  height: 300px;
  margin-top: 5px;

  .legoSelecterCheckbox[type="checkbox"] {
    position: relative;
    left: 10px
  }

  .legoSelecterOptionsContainer {
    max-height: 200px;
    overflow-y: auto;
    padding: 0;
  }
`;

export const FootWrapper = styled.div.attrs(() => ({
  className: 'MoveTeacherFootWrapper',
}))`
  text-align: right;
`;

export const MoveTeacherBtn = styled(Button).attrs(() => ({
  className: 'MoveTeacherButton',
}))`
  ${({ theme }) => theme.breakPoints.tablet} {
    display: inline-block;
    min-width: 170px;
    max-width: 170px;
    width: 170px;
  }
`;
